<header class="baer-header">
    <p class="title-date">{{(today | date: 'EEEE, MMMM d, y')}}</p>
    <p id="table" class="site-page-title" *ngIf="user">Good morning, {{user.first_name}}</p>
</header>
<mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" animationDuration="0ms" [(selectedIndex)]="tabIndex" *ngIf="user">
    <mat-tab>
        <ng-template mat-tab-label>
            <fa-icon [icon]="faHome" style="font-size: 20px;" aria-label="My Dashboard"></fa-icon>&nbsp;
            My Dashboard
        </ng-template>
        <ng-template matTabContent>
            <app-my-dashboard [user]="user" (changeIndex)="indexChange($event)"></app-my-dashboard>
        </ng-template>
    </mat-tab>
    <mat-tab *ngIf="user.woOffice || user.regionOffice || user.forestOffice">
        <ng-template mat-tab-label>
            <fa-icon [icon]="faChartLine" style="font-size: 20px;" aria-label="Current Status"></fa-icon>&nbsp;
            BAER Current Status
        </ng-template>
        <ng-template matTabContent>
            <app-current-status [user]="user" [public]="false"></app-current-status>
        </ng-template>
    </mat-tab>
    <mat-tab *ngIf="user.woOffice || user.regionOffice || user.forestOffice">
        <ng-template mat-tab-label>
            <fa-icon [icon]="faDollarSign" style="font-size: 20px;" aria-label="Authorization Status"></fa-icon>&nbsp;
            BAER Authorization Status
        </ng-template>
        <ng-template matTabContent>
            <app-auth-status [user]="user"></app-auth-status>
        </ng-template>
    </mat-tab>
    <mat-tab>
        <ng-template mat-tab-label>
            <fa-icon [icon]="faCalendarDays" style="font-size: 20px;" aria-label="Annual Comparison"></fa-icon>&nbsp;
            BAER Annual Comparison
        </ng-template>
        <ng-template matTabContent>
            <app-annual-compare></app-annual-compare>
        </ng-template>
    </mat-tab>
</mat-tab-group>
